'use client'

import dynamic from 'next/dynamic'
import React, { useEffect, useState } from 'react'
import ExpandIcon from '@/public/images/icons/expand.svg'
import Delete from '@/public/images/icons/delete.svg'
import './style.css'

const ReactQuill = dynamic(() => import('react-quill'), { ssr: false })
import 'react-quill/dist/quill.snow.css'
import Image from 'next/image'
import EditFullScreen from './EditFullScreen'

const modules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],
    ['link', 'image'],
    ['blockquote', 'code-block'],
    [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
    [{ align: [] }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ color: [] }, { background: [] }],
  ],
}

const WYSIWYGEditor = (
  {
    data,
    title,
    summary,
    hideSection,
    hasCustomField,
    customFieldName = '',
    customFieldDescription = '',
    onUpdateValue,
    showSummary = false,
    customeFieldTitle
  }: {
    data?: string
    title?: string
    summary?: string
    hideSection?: any
    hasCustomField?: boolean
    customFieldName?: string
    customFieldDescription?: string
    onUpdateValue: (value: string, field?: string) => void
    showSummary?: boolean,
    customeFieldTitle?: string
  },
) => {
  const [openModal, setOpenModal] = useState(false)
  const [value, setValue] = useState('')

  useEffect(() => {
    setValue(data || '')
  }, [])

  const updateValue = (value: string, field = '') => {
    if (field !== 'title') {
      setValue(value)
    }
    onUpdateValue(value, field)
  }

  return (
    <>
      <div className="w-full flex flex-col">
        <div className="flex items-end justify-between">
          <label
            className="text-sm font-semibold block text-gray-900 dark:text-white"
          >
            {title}
          </label>
          <div className="flex gap-4">
            {
              hideSection && (
                <Image className="w-4 h-4 ml-auto cursor-pointer"
                       onClick={() => hideSection()}
                       src={Delete} alt="" />
              )
            }
            <Image className="w-4 h-4 ml-auto cursor-pointer"
                   onClick={() => setOpenModal(true)}
                   src={ExpandIcon} alt="" />
          </div>
        </div>
        {
          showSummary &&
          <span className="mt-2 text-gray-500 text-sm leading-tight">
            {summary}
          </span>
        }
        <section className="mt-4">
          <ReactQuill theme="snow"
                      modules={modules}
                      value={value}
                      placeholder="Write text here ..."
                      onChange={(value: any, delta: any, source: any) => {
                        if (source === 'user') {
                          updateValue(value, hasCustomField ? 'value' : '')
                        }
                      }} />
        </section>
      </div>

      <EditFullScreen modules={modules}
                      title={title}
                      summary={summary}
                      isOpen={openModal}
                      hasCustomField={hasCustomField}
                      customFieldName={customFieldName}
                      customeFieldTitle={customeFieldTitle}
                      customFieldDescription={customFieldDescription}
                      setOpenModal={setOpenModal}
                      defaultValue={value}
                      onUpdateTitle={(value: any) => updateValue(value,
                        'title')}
                      onUpdateValue={(value: any) => updateValue(value,
                        'value')} />
    </>
  )
}

export default WYSIWYGEditor
